import { P2GBox } from '@parcel2go/core-ui';

const StickyButtons = ({ children }: { children: React.ReactNode }) => (
  <P2GBox sx={{ zIndex: 2, position: 'sticky', bottom: 0 }}>{children}</P2GBox>
);

export default StickyButtons;
